'use client';

import { Context, useContext } from 'react';

export function useContextHandler<T>(context: Context<T | null>): T {
  const consumer = useContext(context);

  if (consumer === null) {
    throw new Error(`Consumer component is missing a parent provider component.`);
  }

  return consumer;
}
